import { Headers } from 'src/components/shared/ui/table/types';

export const clientsProjectsHeaders: Headers[] = [
  { header: 'Proyecto', key: 'name' },
  { header: 'Critic', key: 'isCritic' },
  { header: 'Inicio', key: 'startDate' },
  { header: 'Fin', key: 'endDate' },
];
